module.exports = {
  'menu.btn.profile': 'Profile',
  'menu.btn.shop': 'Shop',
  'menu.btn.social': 'Social',
  'menu.btn.maps': 'Maps',
  'menu.btn.mods': 'Mods',
  'menu.btn.settings': 'Settings',
  'menu.btn.customize': 'Customize',
  'menu.btn.invite': 'Invite',
  'menu.btn.invite.clicked': 'Copied',
  'menu.btn.join': 'Join',
  'menu.btn.host': 'Host Game',
  'menu.btn.browser': 'Server Browser',
  'generic.wait': 'Please wait...',
  'generic.loading': 'LOADING...',
  'generic.connecting': 'CONNECTING...',
  'generic.none': 'None',
  'generic.select': 'Select',
  'generic.delete': 'Delete',
  'generic.save': 'Save',
  'generic.load': 'Load',
  'generic.search': 'Search',
  'generic.leave': 'Leave',
  'generic.default': 'Default',
  'generic.submit': 'Submit',
  'generic.create': 'Create',
  'generic.failed': 'Failed',
  'generic.success': 'Success!',
  'generic.name': 'Name',
  'generic.level': 'Level',
  'generic.score': 'Score',
  'generic.off': 'Off',
  'generic.score': 'Score',
  'generic.victory': 'VICTORY',
  'generic.defeat': 'DEFEAT',
  'generic.follow': 'Follow',
  'generic.unfollow': 'Unfollow',
  'generic.followers': 'Followers',
  'generic.following': 'following',
  'generic.games': 'Games',
  'generic.wins': 'Wins',
  'generic.clan': 'Clan',
  'generic.kills': 'Kills',
  'generic.deaths': 'Deaths',
  'generic.kdr': 'KDR',
  'generic.games.played': 'Games Played',
  'generic.games.won': 'Games Won',
  'generic.timep': 'Time Played',
  'generic.time': 'Time',
  'generic.logout': 'Logout',
  'generic.logout.sessions': 'Logout of all Sessions',
  'generic.username': 'Enter Username',
  'generic.password': 'Enter Password',
  'generic.register': 'Register',
  'generic.login': 'Login',
  'generic.accuracy': 'Accuracy',
  'player.waiting': 'waiting for players',
  'player.died': 'You died',
  'player.killed': 'Killed By',
  'player.killstreak': '{0} on a {1} Kill Streak',
  'player.inactive': 'Kicked for inactivity',
  'player.disconnect': 'DISCONNECTED',
  'timer.end': 'Next Round in {0}',
  'leaderboard.empty': 'Empty Lobby',
  'popup.checkpoint': 'Checkpoint!',
  'app.play': 'CLICK TO PLAY',
  'app.play.controller': 'PRESS START',
  'purchase.error': 'Error occurred',
  'purchase.error.click': 'click here</a> and try again!',
  'purchase.error.limit': 'You may have exceeded your daily transaction limit',
  'settings.reset': 'Reset Settings',
  'settings.reset.confirm': 'Are you sure you want to reset all your settings? This will also refresh the page',
  'settings.controls.change': 'Change Controls',
  'settings.controls.press': 'Press any Key',
  'settings.server.header': 'Servers',
  'settings.server.region': 'Default Region',
  'settings.quality.header': 'Quality',
  'settings.quality.res': 'Resolution',
  'settings.quality.part': 'Particles',
  'settings.quality.trails': 'Bullet Trails',
  'settings.quality.mflash': 'Muzzle Flash',
  'settings.interface.header': 'Interface',
  'settings.interface.ui': 'Show UI',
  'settings.interface.hp': 'Dynamic HP Bars',
  'settings.interface.chat': 'Show Chat Box',
  'settings.interface.kills': 'Show Kill Feed',
  'settings.interface.messages': 'Show Player Messages',
  'settings.interface.unboxings': 'Show Unboxings',
  'settings.interface.ping': 'Show Ping',
  'settings.interface.fps': 'Show FPS',
  'settings.interface.deaths': 'Show Deaths',
  'settings.crosshair.header': 'Crosshair',
  'settings.crosshair.type': 'Type',
  'settings.crosshair.type.2': 'Custom',
  'settings.crosshair.type.3': 'Layered',
  'settings.crosshair.type.4': 'Image',
  'settings.crosshair.style': 'Style',
  'settings.crosshair.style.0': 'Cross',
  'settings.crosshair.style.1': 'Hollow Circle',
  'settings.crosshair.style.2': 'Solid Circle',
  'settings.crosshair.style.3': 'Hollow Square',
  'settings.crosshair.style.4': 'Solid Square',
  'settings.crosshair.image': 'Image',
  'settings.crosshair.image.paste': 'Crosshair Image',
  'settings.crosshair.always': 'Always Show',
  'settings.crosshair.color': 'Color',
  'settings.crosshair.shadow': 'Shadow',
  'settings.crosshair.size': 'Size',
  'settings.crosshair.thickness': 'Thickness',
  'settings.onKillS.style.0': 'Default',
  'settings.onKillS.style.1': 'Reduce Resolution',
  'settings.onKillS.style.2': 'Reduce FOV',
  'settings.onKillS.style.3': 'Increase FOV',
  'settings.gameplay.header': 'Gameplay',
  'settings.gameplay.sensitivity': 'Sensitivity',
  'settings.gameplay.aimsens': 'Aim Sensitivity',
  'settings.gameplay.fov': 'Field of View',
  'settings.gameplay.streamer': 'Streamer Mode',
  'settings.gameplay.challenge': 'Challenge Mode',
  'settings.gameplay.invert': 'Invert Y-Axis',
  'settings.gameplay.onkillS': 'On Kill',
  'settings.gameplay.scrollDir': 'Scroll Direction',
  'settings.audio.header': 'Audio',
  'settings.audio.sound': 'Sound',
  'settings.audio.voice': 'Voice Volume',
  'settings.viewmodel.header': 'View Model',
  'settings.viewmodel.fps': 'Weapon FOV',
  'settings.viewmodel.bobbing': 'Weapon Bobbing',
  'settings.viewmodel.show.primary': 'Show Primary',
  'settings.viewmodel.show.secondary': 'Show Secondary',
  'settings.viewmodel.show.melee': 'Show Melee',
  'settings.editing.header': 'Editing',
  'settings.editing.health.high': 'HUD Health High',
  'settings.editing.health.low': 'HUD Health Low',
  'settings.editing.depth': 'Depth Map',
  'settings.editing.green': 'Green Screen',
  'settings.shaders.header': 'Shaders',
  'settings.shaders.ambient': 'Ambient Shading',
  'settings.mods.header': 'Mods',
  'settings.mods.load': 'Load Mods',
  'settings.mods.auto': 'Auto-Load Mod',
  'settings.mods.borders': 'Scope Borders',
  'settings.mods.scope': 'Scope Image',
  'settings.mods.scope.paste': 'Scope Image URL',
  'settings.mods.dot': 'Red Dot Image',
  'settings.mods.dot.paste': 'Red Dot URL',
  'settings.mods.endmessage': 'Match End Message',
  'settings.mods.profile': 'Profile Image',
  'settings.mods.profile.paste': 'Profile Image URL',
  'windows.settings.header': 'Game Settings',
  'windows.servers.header': 'Server Browser',
  'windows.servers.none': 'No Joinable Games Found...',
  'windows.servers.host': '+ Host Game',
  'windows.servers.hide': 'Hide Full',
  'windows.servers.online': '{0} total online',
  'windows.loadout.header': 'Change Loadout',
  'windows.loadout.class': 'Class',
  'windows.loadout.primary': 'Primary',
  'windows.loadout.secondary': 'Secondary',
  'windows.loadout.melee': 'Melee',
  'windows.loadout.hat': 'Hat',
  'windows.loadout.body': 'Body',
  'windows.loadout.spray': 'Spray',
  'windows.mods.header': 'Mod Manager',
  'windows.mods.guide': 'Mod Guide',
  'windows.mods.list': 'Mods List',
  'windows.mods.publish': 'Publish Mod',
  'windows.mods.viewer': 'Viewer',
  'windows.mods.drop': 'drop mod file here or click',
  'windows.mods.paste': 'Paste Mod Url',
  'windows.mods.load': 'Load Mod',
  'windows.account.header': 'Account',
  'windows.account.recover': 'To recover an account contact <a>krunker@yendis.ch</a>',
  'windows.class.header': 'Select Class',
  'windows.controls.header': 'Change Controls',
  'windows.controls.forward': 'Forward',
  'windows.controls.backward': 'Backward',
  'windows.controls.left': 'Left',
  'windows.controls.right': 'Right',
  'windows.controls.reload': 'Reload',
  'windows.controls.aim': 'Aim',
  'windows.controls.inspect': 'Inspect',
  'windows.controls.spray': 'Spray',
  'windows.controls.jump': 'Jump',
  'windows.controls.crouch': 'Crouch',
  'windows.controls.prim': 'Primary Weapon',
  'windows.controls.swap': 'Secondary Weapon',
  'windows.controls.melee': 'Melee Weapon',
  'windows.controls.chat': 'Chat',
  'windows.controls.voice': 'Voice',
  'windows.controls.list': 'Player List',
  'windows.controls.interact': 'Interact',
  'windows.controls.drop': 'Drop',
  'windows.host.header': 'Host Custom Game',
  'windows.host.maps': 'Select Maps',
  'windows.host.cmaps': 'Community Map',
  'windows.host.raw': 'Raw Map Data',
  'windows.host.modes': 'Select Modes',
  'windows.host.classes': 'Select Classes',
  'windows.host.settings': 'Server Settings',
  'windows.host.preset': 'Host Presets',
  'windows.host.preset.load': 'Loading Preset...',
  'windows.host.preset.name': 'Preset name',
  'windows.host.start': 'Start Game',
  'windows.spray.header': 'Select Spray',
  'windows.spray.default': 'Default Spray',
  'windows.maps.header': 'Custom Maps',
  'windows.maps.none': 'No maps found!',
  'windows.maps.name': 'Map Name',
  'windows.maps.editor': 'Map Editor',
  'windows.maps.publish': 'Publish Map',
  'windows.maps.community': 'Map Community',
  'windows.publish.map.header': 'Publish Map',
  'windows.publish.map.thumbnail': 'No Thumbnail',
  'windows.publish.map.paste': 'Paste Map Data',
  'windows.publish.map.update': 'Publish/Update',
  'windows.publish.map.login': 'Login</a> to create and upload maps!',
  'windows.theatre.header': 'Theatre Mode',
  'windows.theatre.record': 'Enable Recording',
  'windows.theatre.key': 'Record Key',
  'windows.clans.header': 'Clans',
  'windows.clans.members': 'Members ({0})',
  'windows.clans.requests': 'Requests',
  'windows.clans.requests.none': 'No Requests',
  'windows.clans.page': '[{0}] Clan Page',
  'windows.clans.create': 'Create Clan',
  'windows.clans.name': 'Clan Name',
  'windows.clans.view': 'View Clans',
  'windows.clans.join': 'Join Clan',
  'windows.clans.login': 'Login</a> to create and join a clan!',
  'windows.store.header': 'Store',
  'windows.store.spin': '{0} Spin',
  'windows.store.agree': 'By purchasing you agree to the {0}Terms',
  'windows.store.purchase': 'Purchase KR',
  'windows.store.market': 'Marketplace',
  'windows.store.market2': 'Krunker Market',
  'windows.store.buy': 'Buy and Sell Items on the',
  'windows.store.wheels': 'Prize Wheels',
  'windows.store.unlock': 'Unlock new weapon skins and items',
  'windows.store.amount': '{0} KR in account',
  'windows.store.login': 'Login</a> to buy and unlock items from the store!',
  'windows.store.purchasing': 'Purchasing...',
  'windows.store.unboxed': '{0}{1} unboxed',
  'windows.skin.header': 'Select Skin',
  'windows.hat.header': 'Select Hat',
  'windows.back.header': 'Select Back',
  'windows.melee.header': 'Select Melee',
  'windows.mods.community.header': 'Community Mods',
  'windows.mods.community.fav': 'Your Favorites',
  'windows.mods.community.new': 'New Mods',
  'windows.mods.community.hot': 'Hot',
  'windows.mods.community.name': 'Mod Name',
  'windows.mods.community.none': 'No Mods found!',
  'windows.publish.mod.header': 'Publish Mod',
  'windows.publish.mod.thumbnail': 'No Thumbnail',
  'windows.publish.mod.name': 'Mod Name',
  'windows.publish.mod.paste': 'Mod Url',
  'windows.publish.mod.update': 'Publish/Update',
  'windows.publish.mod.login': 'Login</a> to create and upload mods!',
  'windows.secondary.header': 'Select Secondary',
  'windows.secondary.unlocked': 'Unlocked at lvl {0}',
  'windows.secondary.req': 'Req lvl {0}',
  'windows.advertise.header': 'Advertise',
  'windows.players.header': 'Player List',
  'windows.players.none': 'No players currently...',
  'windows.join.header': 'Join',
  'windows.join.code': 'Enter Game URL/Code',
  'windows.client.header': 'Client',
  'windows.client.windows': 'Windows Installer',
  'windows.client.mac': 'macOS Installer',
  'windows.client.linux': 'Linux Installer',
  'thumbnail.upload.limit': 'Failed. 40kb Thumbnail Limit',
  'thumbnail.upload.error': 'Thumbnail Error',
  'mod.extracting': 'extracting {0}/{1}',
  'mod.disabled': 'mods disabled',
  'mod.error': 'mod error!',
  'mod.loading': 'loading mod...',
  'mod.invalid': 'invalid mod file!',
  'matchmaker.full': 'FULL',
  'matchmaker.full2': 'Game is full.',
  'matchmaker.none': 'Game not found.',
  'adblocker': 'Disable your ad blocker to receive free Krunkies.',
  'streamers.views': '{0} viewers',
  'streamers.none': 'No active streams!',
  'error.extentions': 'If you have any extensions. Disable them',
  'error.seek': 'Try seeking a new game by clicking',
  'custom.map.missing': 'Select at least one Map',
  'custom.mode.missing': 'Select at least one Mode',
  'custom.class.missing': 'Select at least one Class',
  'server.config.maxPlayers': 'Players',
  'server.config.minPlayers': 'Min Players',
  'server.config.lives': 'Lives',
  'server.config.gameTime': 'Minutes',
  'server.config.gravMlt': 'Gravity',
  'server.config.jumpMlt': 'Jump Force',
  'server.config.deltaMlt': 'Time Scale',
  'server.config.strafeSpd': 'Strafe Speed',
  'server.config.healthMlt': 'Health Multiplier',
  'server.config.impulseMlt': 'Weapon Impulse',
  'server.config.nameTeam1': 'Team 1 Name',
  'server.config.nameTeam2': 'Team 2 Name',
  'server.config.selTeam': 'Select Team',
  'server.config.allowSpect': 'Spectating',
  'server.config.killRewards': 'Kill Rewards',
  'server.config.headshotOnly': 'Headshots Only',
  'server.config.canSlide': 'Sliding',
  'server.config.autoJump': 'Auto Jump',
  'server.config.thirdPerson': '3rd Person',
  'server.config.nameTags': 'Hide Nametags',
  'server.config.private': 'Private',
  'social.login': 'Login/Register',
  'social.login.failed': 'Login Failed',
  'social.login.buy': 'Login to Buy',
  'social.login.sell': 'Login to Sell',
  'social.login.gift': 'Login to Gift',
  'social.login.proccessing': 'Logging in...',
  'social.since': 'Since',
  'social.user.maps': 'User Maps',
  'social.user.mods': 'User Mods',
  'social.maps.none': 'No Maps found...',
  'social.market.head': 'Head Item',
  'social.market.back': 'Back Item',
  'social.market.melee': 'Melee Item',
  'social.market.none': 'No Items Found',
  'social.market.grace': 'ready in {0}',
  'social.market.sort': 'Filter/Sort',
  'social.market.filter': 'Search',
  'social.market.price.high': 'Highest Price',
  'social.market.price.low': 'Lowest Price',
  'social.market.price.list': 'List Price in',
  'social.market.searching': 'Searching',
  'social.market.listed': 'listed {0} ago',
  'social.market.list': 'List Item',
  'social.market.unlist': 'Unlist',
  'social.market.unlisting': 'Unlisting Item...',
  'social.market.posting': 'Posting Item...',
  'social.market.req': 'lvl {0} required',
  'social.market.cant': "Can't Afford",
  'social.market.purchase': 'Purchase',
  'social.market.fee': 'No List Fee',
  'social.market.failed': 'Failed. Try Again',
  'social.market.gift.amount': 'Gift Amount in',
  'social.market.fee.gift': 'No Gift Fee',
  'social.market.gift': 'Gift KR'
};